import { useEffect, useState } from 'react';
import { P } from '../ui';
import content from '../../content';
import type { PageInformation } from '../../config/types';
import { parseSafeHtml } from '../../utils/safe-html';
import Checkbox from './Checkbox';

export default function InformationPageTemplate({
  config,
  onContinue,
  disabled,
}: {
  config: PageInformation;
  onContinue: () => void;
  disabled?: boolean;
}) {
  const [confirmationChecked, setConfirmationChecked] = useState(false);

  useEffect(() => {
    setConfirmationChecked(false);
  }, [config.name, config.description, config.continueConfirmation]);

  return (
    <>
      {(config.description ?? '').split('\n').map((paragraph) => (
        <P className={config.descriptionClassName} key={paragraph.substring(0, 20)}>
          {parseSafeHtml(paragraph)}
        </P>
      ))}
      {config.continueConfirmation && (
        <div className="govuk-form-group">
          <div className="govuk-checkboxes" data-module="govuk-checkboxes">
            <div className="govuk-checkboxes__item">
              <Checkbox
                id="information-continue-confirmation"
                name="information-continue-confirmation"
                checked={confirmationChecked}
                onChange={(event) => setConfirmationChecked(event.target.checked)}
              />
              <label
                className="govuk-label govuk-checkboxes__label"
                htmlFor="information-continue-confirmation"
              >
                {config.continueConfirmation}
              </label>
            </div>
          </div>
        </div>
      )}
      <button
        data-testid="information-continue-btn"
        className="govuk-button"
        data-module="govuk-button"
        data-prevent-double-click="true"
        onClick={onContinue}
        type="button"
        disabled={(disabled ?? false) || (!!config.continueConfirmation && !confirmationChecked)}
      >
        {content.buttonContinue}
      </button>
    </>
  );
}
